import { RouterModule, Routes } from '@angular/router';
import { ClientPreQualificationsComponent } from './client-pre-qualifications.component';
import { NgModule } from '@angular/core';
import { AuthGuard } from '../../guards/auth.guard';

const routes: Routes = [
  {
    path: 'my-prequalifications',
    canActivate: [
      AuthGuard
    ],
    children: [
      { 
        path: '', 
        component: ClientPreQualificationsComponent 
      }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class ClientPreQualificationsRoutingModule {}
